import { useState, useEffect, useRef } from "react";
import { connect, RootStateOrAny } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { useHistory } from "react-router";

import moment from "moment";
import _, { debounce } from "lodash";

import {
  Select,
  Input,
  Radio,
  Button,
  TimePicker,
  AutoComplete,
  Table,
  Modal,
  Form,
  Alert,
  Spin,
  Space,
  Divider,
} from "antd";
import Title from "antd/lib/typography/Title";
import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";
import { toLetters, validateCharges } from "utils/helpers";
import { states } from "utils/objects";
import { ResubCodes } from "utils/enums";

import { create } from "store/claim/actions";
import {
  getProviderNPI,
  checkIsDME,
  validateRendering,
  verify,
  getOther,
  getName as getNameFromNpi,
  getRmiProvKeyId,
  getNameAndIdFromRmiProvKeyId,
} from "store/claim/npi/actions";
import { getVendors } from "store/app/actions";
import { getAuthModifierCode } from "store/authorization/modifierCode/actions";
import { getPos } from "store/authorization/pos/actions";
import { checkMediCalCode } from "store/authorization/mediCal/actions";
import { getDiagCodes } from "store/authorization/diagCodes/actions";
import { get as getCPTCodes, searchByType } from "store/claim/cptCodes/actions";
import { getAuthDetail } from "store/claim/member/actions";
import {
  checkCPTCompatibility,
  getRelated,
  getNdcCodes,
  checkIfNdcIsRequired,
} from "store/claim/ndc/actions";
import {
  getFacilities,
  getClaimsFacilities,
  IClaimsFacilities,
  IFacilities,
} from "store/authorization/facilities/actions";
import {
  uploadAttachment,
  getInvalidPrimDxInitials,
} from "store/claim/actions";

import FloatLabel from "components/Common/FloatLabel";
import LoadingIndicator from "components/Common/LoadingIndicator";
import DropzoneLocal from "components/Common/Dropzone";
import DatePickerLocalised from "components/Common/DatePickerLocalised";

import constants from "constants/index";
import PatientInfo from "./PatientInfo";
import { EMCodeSelectionModal, OtherProviderModal } from "./Modals";
import { ProcedureTable } from "./Tables";
import {
  ClaimInfoProps,
  DiagInfo,
  ProcInfo,
  RenderingProviderDetails,
} from "./Proptypes";
import {
  AMBULATORY_CODES,
  EM_EXCLUSION_CODES,
  G_CODES,
  HOSPITALIZATION_REQUIRED_POS_CODE,
} from "./Codes";
import { validateNDC } from "./Validators";

import "./index.scss";

const { Option } = Select;
const { confirm } = Modal;

// TODO:
// CheckisDME
// SL Modifier
// HEDIS Measures

const ClaimInfo = (props: ClaimInfoProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [attachmentList, setAttachmentList] = useState<any[]>([]);

  // Dates
  const [currentDate, setCurrentDate] = useState("");
  const [otherDate, setOtherDate] = useState("");
  const [hospitalFrom, setHospitalFrom] = useState("");
  const [hospitalTo, setHospitalTo] = useState("");
  const [unavailableFrom, setUnavailableFrom] = useState("");
  const [unavailableTo, setUnavailableTo] = useState("");
  const [dosFrom, setDosFrom] = useState("");
  const [dosTo, setDosTo] = useState("");

  //NPI info
  const [npi, setNpi] = useState("");
  const [referringProvider, setReferringProvider] = useState("");
  const [resubCode, setResubCode] = useState("");

  // procedure info
  const [procedure, setProcedure] = useState("NDC");
  const [cpt, setCPT] = useState<any>({});
  const [pos, setPOS] = useState("");
  const [posOffice, setPosOffice] = useState(true);
  const [additionalDiags, setAdditionalDiags] = useState<any>({});

  // API Results
  const [diagCodeResult, setDiagCodeResult] = useState<any[]>([]);
  const [ndcCodeResult, setNdcCodeResult] = useState<any[]>([]);
  const [diagDataSource, setDiagDataSource] = useState<any[]>([]);
  const [CPTCodesResult, setCPTCodesResult] = useState<any[]>([]);
  const [modifierCodes, setModifierCodes] = useState<any[]>([]);
  const [procDataSource, setProcDataSource] = useState<any[]>([]);
  const [vendors, setVendors] = useState<any[]>([]);
  const [posList, setPosList] = useState<any[]>([]);
  const [otherProviders, setOtherProviders] = useState<any[]>([]);
  const [patientAccount, setPatientAccount] = useState("");
  const [amountPaid, setAmountPaid] = useState("0");
  const [totalCharges, setTotalCharges] = useState("0");
  const [balance, setBalance] = useState("0");
  const [facilities, setFacilities] = useState<any[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<any>({});
  const [EMCodes, setEMCodes] = useState<any[]>([]);
  const [measureCodes, setMeasureCodes] = useState<any[]>([]);
  const [mediCalCheck, setMediCalCheck] = useState(false);

  const [datesVisible, setDatesVisible] = useState(false);
  const [totalTime, setTotalTime] = useState("");
  const [totalTimeInMinutes, setTotalTimeInMinutes] = useState(0);

  const [portalClaimMaster, setPortalClaimMaster] = useState<any>({});
  const [patientInfo, setPatientInfo] = useState<any>({});

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otherProviderModalVisible, setOtherProviderModalVisible] =
    useState(false);
  const [ndcRequired, setNdcRequired] = useState(false);
  const [EMCodeSelectionModalVisible, setEMCodeSelectionModalVisible] =
    useState(false);
  const [selectedEMCode, setSelectedEMCode] = useState("");
  const [sameNPI, setSameNPI] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [disableCptCode, setDisableCptCode] = useState(false);
  const scrollToRef = useRef<null | HTMLDivElement>(null);
  const [vendorFromDate, setVendorFromDate] = useState("");
  const [vendorToDate, setVendorToDate] = useState("");
  const [invalidPrimDxInitials, setInvalidPrimDxIntials] = useState<string[]>(
    []
  );
  const [diagErrorMsg, setDiagErrorMsg] = useState("");

  const diagColumns = [
    {
      title: "REMOVE",
      key: "index",
      dataIndex: "index",
      render: (_: string, record: any, index: number) => (
        <a onClick={() => handleRemoveDiag(index, record)}>
          <DeleteOutlined />
        </a>
      ),
    },
    {
      title: "DIAG REF",
      key: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: any) => toLetters(index + 1),
    },
    {
      title: "DIAGNOSIS CODE",
      key: "RmiDiagCode",
      dataIndex: "RmiDiagCode",
    },
    {
      title: "DESCRIPTION",
      key: "RmiDiagDesc",
      dataIndex: "RmiDiagDesc",
    },
  ];

  useEffect(() => {
    window.addEventListener("popstate", backEvent);
    return () => {
      window.removeEventListener("popstate", backEvent);
    };
  }, []);

  useEffect(() => {
    create();
    getProviderNPI();
    getPOS();
    getAuthModifierCodes();
    getVendors();
    getCPTByType(
      "CPT.EvaluationAndManagement,CPT.PreventiveMedicineServices,CPT.GCodes",
      setEMCodes
    );
    getCPTByType("CPT.CatII", setMeasureCodes);
    checkMediCalCode();
    getInvalidPrimDxInitials();
    setDosFrom(props.dos);
    setDosTo(props.dos);
    const vendorFromDateValue = form.getFieldValue("vendorFromDate");
    const vendorToDateValue = form.getFieldValue("vendorToDate");
    setVendorFromDate(vendorFromDateValue);
    setVendorToDate(vendorToDateValue);
  }, []);

  useEffect(() => {
    if (cpt.RmiProcCode) form.validateFields(["ndcCode"]);
  }, [cpt]);

  useEffect(() => {
    form.validateFields([
      "hospitalFrom",
      "hospitalTo",
      "procedureFrom",
      "procedureTo",
      "unavailableFrom",
      "unavailableTo",
      "npi",
      "provider",
      "priorAuthNo",
      "vendorFromDate",
      "vendorToDate",
    ]);
  }, [
    hospitalFrom,
    hospitalTo,
    dosFrom,
    dosTo,
    unavailableFrom,
    unavailableTo,
    procDataSource,
    npi,
    referringProvider,
    resubCode,
    vendorFromDate,
    vendorToDate,
  ]);

  const backEvent = (e: any) => {
    if (e.state === null) {
      e.preventDefault();
      return false;
    }

    history.push("/claims/create");
    return props.setPage("start");
  };

  const create = () => {
    return props
      .create(
        props.claim.RmiCompanyId,
        props.claim.RmiMembKeyId,
        props.claim.RmiProviderKeyId,
        sessionStorage.getItem("user_id")!,
        props.claim.RmiHpCode,
        props.claim.RmiStartDate
      )
      .then((response: any) => {
        // TODO : RmiClaimSource
        setPortalClaimMaster(response.portalClaimMaster);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const checkMediCalCode = () => {
    return props
      .checkMediCalCode(props.claim.RmiHpCode)
      .then((response: boolean) => {
        setMediCalCheck(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getInvalidPrimDxInitials = () => {
    return props
      .getInvalidPrimDxInitials(props.claim.RmiCompanyId)
      .then((response: string[]) => {
        setInvalidPrimDxIntials(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getProviderNPI = () => {
    return props
      .getProviderNPI(props.claim.RmiProviderKeyId, props.claim.RmiCompanyId)
      .then((response: string) => {
        response
          ? form.setFieldsValue({ renderingProvider: response.trim() })
          : getOtherProviderNPI();
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getOtherProviderNPI = () => {
    return props
      .getOther(props.claim.RmiProviderKeyId, props.claim.RmiCompanyId)
      .then((response: any[]) => {
        if (response.length !== 0) {
          setOtherProviderModalVisible(true);
          setOtherProviders(response);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getPOS = () => {
    return props
      .getPos(props.claim.RmiCompanyId)
      .then((response: any[]) => {
        const office = response.find((x) => x.RmiCode === "11");
        setPOS(office.Code); // Default set to OFFICE
        setPosList(response);
        form.setFieldsValue({ pos: JSON.stringify(office) });
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getAuthModifierCodes = () => {
    props
      .getAuthModifierCode()
      .then((response: any[]) => {
        setModifierCodes(response);
      })
      .catch((err: any) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getVendors = () => {
    return props
      .getVendors(props.claim.RmiProviderKeyId, props.claim.RmiCompanyId)
      .then((response: any[]) => {
        setVendors(response);
        var vendorTaxId = form.getFieldValue("vendorTaxId");

        const matchedVendor = response.find(
          (value: any) => value.RmiTaxId === vendorTaxId
        );
        if (matchedVendor) {
          const formattedFromDate = matchedVendor.RmiFromDate
            ? moment(matchedVendor.RmiFromDate).format("YYYY-MM-DD")
            : "";
          const formattedThruDate = matchedVendor.RmiThruDate
            ? moment(matchedVendor.RmiThruDate).format("YYYY-MM-DD")
            : "";
          setVendorFromDate(formattedFromDate);
          setVendorToDate(formattedThruDate);

          form.setFields([
            { name: "vendorFromDate", value: formattedFromDate },
            { name: "vendorToDate", value: formattedThruDate },
            { name: "vendorTaxId", value: matchedVendor?.RmiFedTaxId },
            { name: "vendorNPI", value: matchedVendor?.RmiBillingProviderNpi },
            {
              name: "vendorName",
              value: matchedVendor?.RmiBillingProviderName,
            },
            {
              name: "vendorAddress",
              value: matchedVendor?.RmiBillingProviderAddress,
            },
            {
              name: "vendorCity",
              value: matchedVendor?.RmiBillingProviderCity,
            },
            {
              name: "vendorState",
              value: matchedVendor?.RmiBillingProviderState,
            },
            { name: "vendorZip", value: matchedVendor?.RmiBillingProviderZip },
            {
              name: "vendorPhone",
              value: matchedVendor?.RmiBillingProviderPhone,
            },
          ]);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const verifyNPI = (npi: string) => {
    return props
      .verify(npi)
      .then((response: boolean) => {
        return response;
      })
      .catch((err: any) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getAuthDetail = (authNo: string) => {
    return props
      .getAuthDetail(
        props.claim.RmiMembKeyId,
        props.claim.RmiProviderKeyId,
        authNo
      )
      .then((response: any[]) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const checkCPTCompatibility = (cpt: string, ndc: string) => {
    return props
      .checkCPTCompatibility(cpt, ndc ? ndc.replace(/\D/g, "") : null)
      .then((response: boolean) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const validateRenderingNpi = (npi: string) => {
    return props
      .validateRendering(
        npi,
        props.claim.RmiProviderKeyId,
        props.claim.RmiCompanyId
      )
      .then((response: boolean) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const verifyRenderingNpi = (npi: string) => {
    return props
      .getRmiProvKeyId(npi, props.claim.RmiCompanyId)
      .then((response: string) => {
        return response !== "00000000-0000-0000-0000-000000000000";
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getFacilities = (selectedPOS: any) => {
    let searchObject = {
      POS: selectedPOS.RmiCode,
      RmiCompanyId: props.claim.RmiCompanyId,
      SpecialGroupId: "",
    };

    return props
      .getFacilities(searchObject)
      .then((response: any[]) => {
        return response;
      })
      .then((facilities: any[]) => {
        let searchObject = {
          ProvKeyId: props.claim.RmiProviderKeyId,
          CompanyId: props.claim.RmiCompanyId,
        };

        return props
          .getClaimsFacilities(searchObject)
          .then((claimFacilities: any) => {
            //default to office type 1 facility
            let defaultFacility: IFacilities = {
              AddressId: null,
              City: null,
              LastName: null,
              Phone: null,
              ProvKeyId: null,
              State: null,
              Street: null,
              Zip: null,
            };

            let npiType2 = "";

            if (claimFacilities?.length > 0) {
              claimFacilities.forEach((facility: any) => {
                const newFacility: IFacilities = {
                  AddressId: facility?.RmiUid,
                  City: facility?.RmiCity,
                  LastName: `${facility?.RmiLastName} ${
                    facility.OfficeType?.match(/\d+/)[0]
                  }`,
                  Phone: facility?.RmiPhone,
                  ProvKeyId: facility?.RmiProvKeyId,
                  State: facility?.RmiState,
                  Street: facility?.RmiStreet,
                  Zip: facility?.RmiZip,
                };

                if (facility.OfficeType === "OFFICE 1") {
                  defaultFacility = newFacility;
                  npiType2 = facility.RmiOutsideId;

                  // set facility NPI-Type 2 field
                  form.setFieldsValue({
                    facilityNPI: npiType2,
                    facility: JSON.stringify(defaultFacility),
                  });

                  // auto populate default facility if there is office type 1 (latest address)
                  setSelectedFacility(defaultFacility);
                  form.setFields([
                    { name: "facilityName", value: defaultFacility.LastName },
                    { name: "facilityAddress", value: defaultFacility.Street },
                    { name: "facilityCity", value: defaultFacility.City },
                    { name: "facilityState", value: defaultFacility.State },
                    { name: "facilityZip", value: defaultFacility.Zip },
                  ]);

                  form.validateFields([
                    "facility",
                    "facilityName",
                    "facilityAddress",
                    "facilityCity",
                    "facilityState",
                    "facilityZip",
                  ]);
                }

                facilities.push(newFacility);
              });
            }

            setFacilities(facilities);
          })
          .catch((err: ErrorResponse) => {
            notifier.error(
              err?.response?.data?.Message ||
                "Something went wrong, please contact a system administrator."
            );
          });
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getCPTByType = (cptType: string, set: Function) => {
    return props
      .searchByType(sessionStorage.getItem("user_id")!, cptType)
      .then((response: any[]) => {
        set(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const calculateTotalTime = () => {
    const start = form.getFieldValue("ndcFrom");
    const end = form.getFieldValue("ndcTo");

    if (!start || !end) {
      setTotalTime(`0 hours 0 minutes`);
      setTotalTimeInMinutes(0);
      return;
    }

    let duration = moment.duration(end.diff(start));
    let hours = duration.hours() > 0 ? duration.hours() : 0;
    let minutes = duration.minutes() > 0 ? duration.minutes() : 0;

    setTotalTime(`${hours} hours ${minutes} minutes`);
    setTotalTimeInMinutes(Math.ceil(duration.asMinutes()));
  };

  const clickOtherProvider = (npi: string) => {
    form.setFieldsValue({ renderingProvider: npi });
    setOtherProviderModalVisible(false);
  };

  const handleDiagCodeSearch = (value: string) => {
    if (value.length < 3) return;
    let searchObject = {
      actionDate: moment().format("MM-DD-YYYY"),
      companyId: props.claim.RmiCompanyId,
      diagCode: value,
      endDate: props.claim.RmiTermDate,
      iCDVersion: constants.ICD_VERSION,
      startDate: props.claim.RmiStartDate,
    };
    props
      .getDiagCodes(searchObject)
      .then((response: any) => {
        setDiagCodeResult(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const tabSelectEvent = (evt: any, searchResult: any[], id: string) => {
    if (searchResult.length > 0 && evt.key === "Tab") {
      const enterKey = new KeyboardEvent("keydown", {
        code: "Enter",
        key: "Enter",
        charCode: 13,
        keyCode: 13,
        view: window,
        bubbles: true,
      });

      document.getElementById(id)!.dispatchEvent(enterKey);
    }
  };

  const handleSelectDiagCode = (value: string, option: any) => {
    let diag = JSON.parse(value);
    form.setFieldsValue({ diagnosis: diag.diagcode });

    if (
      diagDataSource.length == 0 &&
      diag.RmiDiagCode !== null &&
      invalidPrimDxInitials.includes(diag.RmiDiagCode[0])
    ) {
      setDiagErrorMsg(
        "Primary diagnosis can not be a diag starting with V, W, X or Y."
      );
      setTimeout(() => {
        setDiagErrorMsg("");
      }, 5000);
      form.setFieldsValue({ diagnosis: "" });
      return;
    }

    // cannot have more than 12 diagnoses on the table
    if (diagDataSource.length >= 12) {
      notifier.error("Cannot have more than 12 diagnoses listed for 1 claim.");
      return;
    }

    if (constants.ICD_VERSION === 10 && diag.RmiSpecificity === false) {
      // throw error
      notifier.error(
        "This code is not billable or specific ICD-10-CM diag code. Please select a more specific diagnosis."
      );
      return;
    }

    for (let i = 0; i < diagDataSource.length; i++) {
      if (diagDataSource[i].RmiDiagCode === diag.RmiDiagCode) {
        // duplicate
        notifier.error(
          "Duplicate Diagnosis Code exists. Please select a different diagnosis."
        );
        return;
      }
    }

    // Add to table
    setDiagDataSource((prev) => {
      form.setFieldsValue({ diagnosis: "" });

      // add to Diagnoses in Procedure Info
      setAdditionalDiags({
        ...diag,
        index: prev.length + 1,
        letterIndex: toLetters(prev.length + 1),
      });
      form.setFieldsValue({ additionalDiags: diag.RmiDiagCode });
      return [
        ...prev,
        {
          ...diag,
          index: prev.length + 1,
          letterIndex: toLetters(prev.length + 1),
        },
      ];
    });
  };

  const handleRemoveDiag = (index: number, record: any) => {
    if (
      procDataSource.length !== 0 &&
      procDataSource.find((x) => x.diagRef === toLetters(index + 1))
    ) {
      Modal.error({
        title: "Oops!",
        content:
          "There is a service line referring to this diagnosis code. Please remove the service line first.",
      });
    } else {
      var diags = diagDataSource.filter((_, i) => i !== index);

      if (
        diags.length > 0 &&
        diags[0].RmiDiagCode !== null &&
        invalidPrimDxInitials.includes(diags[0].RmiDiagCode[0])
      ) {
        form.setFieldsValue({ diagnosis: "" });
        setDiagErrorMsg(
          "This diagnosis can not be removed as it is immediately followed by diag starting V, W, X or Y."
        );
        setTimeout(() => {
          setDiagErrorMsg("");
        }, 5000);
        return;
      }
      setDiagDataSource((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleNdcCodeSearch = (value: string) => {
    if (value.length < 4) return;

    props
      .getNdcCodes(value)
      .then((response: any) => {
        setNdcCodeResult(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const handleSelectNdcCode = (value: string, option: any) => {
    let selectedNdc = JSON.parse(value);
    form.setFieldsValue({ ndcCode: selectedNdc.code });
  };

  const handleCPTCodeSearch = (value: string) => {
    if (value.length < 2) return;

    const phCode =
      !["ALPHA", "CFC"].includes(props.provider.RmiCompanyId) &&
      [
        "21",
        "22",
        "23",
        "24",
        "31",
        "32",
        "33",
        "51",
        "61",
        "62",
        "65",
      ].includes(JSON.parse(form.getFieldValue("pos")).RmiCode)
        ? "H"
        : "P";
    const searchObject = {
      RmiSpecialtyProvKeyId: props.claim.RmiProviderKeyId,
      RmiCompanyId: props.claim.RmiCompanyId,
      CPTCode: value,
      RmiHpCode: props.claim.RmiHpCode,
      RmiPhCode: phCode,
      RmiMembKeyId: props.claim.RmiMembKeyId,
      ICDCode: additionalDiags.RmiDiagCode,
      RmiStartDate: form.getFieldValue("procedureFrom")
        ? moment(form.getFieldValue("procedureFrom")).format(
            "YYYY-MM-DDTHH:mm:ss"
          )
        : null,
      RmiEndDate: form.getFieldValue("procedureTo")
        ? moment(form.getFieldValue("procedureTo")).format(
            "YYYY-MM-DDTHH:mm:ss"
          )
        : null,
    };
    props
      .getCPTCodes(searchObject)
      .then((response: any[]) => {
        const unique = response.filter(
          (ele: any, ind: number) =>
            ind ===
            response.findIndex(
              (elem: any) => elem.RmiProcCode === ele.RmiProcCode
            )
        );
        setCPTCodesResult(unique);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const handleCPTCodeSelect = (value: string) => {
    const parsed = JSON.parse(value || "{}");
    setNdcRequired(false);

    // MedicalRX Warning
    if (mediCalCheck && parsed && parsed.MedicalRxExclusion) {
      Modal.error({
        title: "Medi-Cal RX Program",
        content: (
          <>
            Requested services are covered under Medi-Cal Rx Program. <br />
            Please choose one of the external links to submit your request:{" "}
            <br /> <br />
            <a href="https://medi-calrx.dhcs.ca.gov/provider/" target="_blank">
              <b>https://medi-calrx.dhcs.ca.gov/provider/</b>
            </a>
            <br />
            <a href="https://account.covermymeds.com/" target="_blank">
              <b>https://account.covermymeds.com/</b>
            </a>
          </>
        ),
        maskClosable: false,
      });
      form.resetFields([
        "cpt",
        "units",
        "modifier",
        "additionalDiags",
        "additionalAddedDiags",
        "additionalModifiers",
      ]);
      setCPTCodesResult([]);
    } else {
      setNdcRequired(parsed.IsNdcRequired);

      setCPT(parsed);
      form.setFieldsValue({ cpt: parsed.ServiceCode });
      form.setFieldsValue({ units: 1 });
      form.setFieldsValue({ ndcCode: "" });
    }
  };

  const validateProcedure = () => {
    // Validate fields
    setIsSubmitting(false);
    form
      .validateFields([
        "diagnosis",
        "procedure",
        "ndcCode",
        "ndcUnit",
        "ndcQty",
        "ndcFrom",
        "ndcTo",
        "procedureFrom",
        "procedureTo",
        "pos",
        "emg",
        "cpt",
        "procedureCharges",
        "units",
        "renderingProvider",
        "modifier",
        "additionalDiags",
        "additionalAddedDiags",
        "additionalModifiers",
        "additionalServiceInfo",
      ])
      .then((values: any) => {
        // check service charge value
        if (values.procedureCharges >= 10000) {
          confirm({
            title: "Are you sure you would like to add this service line?",
            icon: <ExclamationCircleOutlined />,
            content:
              "The charges for this service code equal or exceed $10,000.",
            onOk: () => addToProcTable(values),
            onCancel() {},
          });
        } else {
          addToProcTable(values);
        }
      })
      .catch((err) => {
        notifier.error(
          "Please fix the highlighted fields before adding a Procedure."
        );
      });
  };

  const addToProcTable = (values: any) => {
    // Add to Table
    let row = {
      key: procDataSource.length.toString(),
      fromTo: (
        <>
          {" "}
          {moment(values.procedureFrom).format("MM/DD/YYYY")} <br />{" "}
          {moment(values.procedureTo).format("MM/DD/YYYY")}{" "}
        </>
      ),
      procedureFrom: values.procedureFrom,
      procedureTo: values.procedureTo,
      POS: values.pos,
      EMG: values.emg,
      CPT: cpt.RmiProcCode,
      modifiers: values.modifier,
      diagRef: additionalDiags.letterIndex,
      charges: values.procedureCharges,
      daysOrUnits: parseInt(values.units),
      providerNPI: values.renderingProvider,
      procedure: values.procedure,
      ndcCode: values.ndcCode ? values.ndcCode.trim().replace(/\D/g, "") : null, // valid NDC Code: 43825010201
      ndcUnit: values.ndcUnit,
      ndcQty: values.ndcQty,
      ndcTime: totalTime,
      ndcTimeInMinutes: totalTimeInMinutes,
      ndcFrom: values.ndcFrom,
      ndcTo: values.ndcTo,
      diagCode: additionalDiags.RmiDiagCode,
      diagIndex: additionalDiags.index,
      additionalModifiers: values.additionalModifiers,
      additionalDiags: values.additionalAddedDiags,
      additionalServiceInfo: values.additionalServiceInfo,
    };

    for (let i = 0; i < procDataSource.length; i++) {
      let rowDosFrom = moment(row.procedureFrom);
      let rowDosTo = moment(row.procedureTo);
      let procDosFrom = moment(
        moment(procDataSource[i].procedureFrom).format("MM/DD/YYYY")
      );
      let procDosTo = moment(
        moment(procDataSource[i].procedureTo).format("MM/DD/YYYY")
      );
      let pos = JSON.parse(values.pos).RmiCode;

      if (
        ["21", "31", "32", "33"].includes(pos) &&
        !(
          moment(rowDosFrom).isSame(procDosFrom) &&
          moment(rowDosTo).isSame(procDosTo)
        )
      ) {
        continue;
      }
      if (procDataSource[i].CPT === row.CPT) {
        // duplicate
        notifier.error(
          "Duplicate CPT Code exists. Please select a different CPT code."
        );
        return;
      }
    }

    // Check if different POS
    if (JSON.parse(values.pos).Code !== pos && procDataSource.length !== 0) {
      // Different POS
      confirm({
        title: "Place of Service Difference.",
        icon: <ExclamationCircleOutlined />,
        content:
          "The POS on all service lines will be modified to match this one.",
        onOk: () => handlePos(values, row, true),
        onCancel() {},
      });
    } else {
      // Same POS
      if (procDataSource.length === 0) setPOS(JSON.parse(values.pos).Code);
      handlePos(values, row, false);
    }
  };

  const handlePos = (values: any, row: any, newPos: boolean) => {
    const selectedPOS = JSON.parse(values.pos);

    if (
      selectedPOS.RmiCode === "11" ||
      selectedPOS.RmiCode === "02" ||
      selectedPOS.RmiCode === "10"
    )
      setPosOffice(true);
    else setPosOffice(false);

    if (newPos) {
      setPOS(selectedPOS.Code); // Set POS to current
      setProcDataSource((prev) =>
        prev.map((val) => {
          return { ...val, POS: values.pos };
        })
      );
    }

    // Clear CPT and Charges
    form.resetFields([
      "cpt",
      "procedureCharges",
      "emg",
      "modifier",
      "units",
      "additionalModifiers",
      "additionalAddedDiags",
      "ndcCode",
    ]);
    setCPTCodesResult([]);
    setCPT({});
    setNdcRequired(false);

    // Get Name from NPI
    props
      .getRmiProvKeyId(values.renderingProvider, props.claim.RmiCompanyId)
      .then((response: string) => {
        props
          .getNameAndIdFromRmiProvKeyId(response)
          .then((response: RenderingProviderDetails) => {
            setProcDataSource((prev) => [...prev, { ...row, ...response }]);
          });
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });

    // Get Facilities
    getFacilities(selectedPOS);
  };

  const addEMCodetoProcTable = () => {
    if (selectedEMCode === "") return;
    else {
      const procData = {
        key: procDataSource.length.toString(),
        fromTo: (
          <>
            {" "}
            {moment(props.dos).format("MM/DD/YYYY")} <br />{" "}
            {moment(props.dos).format("MM/DD/YYYY")}{" "}
          </>
        ),
        procedureFrom: props.dos,
        procedureTo: props.dos,
        POS: form.getFieldValue("pos"),
        EMG: "N",
        CPT: selectedEMCode,
        modifiers: null,
        diagRef: additionalDiags.letterIndex,
        charges: "0.01",
        daysOrUnits: 1,
        providerNPI: form.getFieldValue("renderingProvider"),
        procedure: "NDC",
        ndcCode: null,
        ndcUnit: "ML",
        ndcQty: "1",
        ndcTime: null,
        ndcTimeInMinutes: null,
        ndcFrom: null,
        ndcTo: null,
        diagCode: additionalDiags.RmiDiagCode,
        diagIndex: additionalDiags.index,
        additionalModifiers: null,
        additionalDiags: null,
        additionalServiceInfo: null,
      };
      setProcDataSource((prev) => [...prev, procData]);
      setEMCodeSelectionModalVisible(false);
      Modal.success({
        title:
          selectedEMCode + " has been successfully added as a service line.",
        content:
          "Please re-submit the form after confirming the added information is correct.",
      });
    }
  };

  const validateDos = (formName: string) => {
    if (formName === "procedureFrom") {
      if (!form.validateFields(["procedureFrom"])) {
        setDisableCptCode(true);
      }
    }

    if (formName === "procedureTo") {
      if (!form.validateFields(["procedureTo"])) {
        setDisableCptCode(true);
      }
    }
  };

  const handleSelectVendor = (value: string) => {
    let vendor = JSON.parse(value);
    const formattedFromDate = vendor.RmiFromDate
      ? moment(vendor.RmiFromDate).format("YYYY-MM-DD")
      : "";
    const formattedThruDate = vendor.RmiThruDate
      ? moment(vendor.RmiThruDate).format("YYYY-MM-DD")
      : "";
    setVendorFromDate(formattedFromDate);
    setVendorToDate(formattedThruDate);

    form.setFields([
      { name: "vendorTaxId", value: vendor.RmiTaxId }, // Add TaxId to the create claim payload
      { name: "vendorFromDate", value: formattedFromDate },
      { name: "vendorToDate", value: formattedThruDate },
      { name: "vendorNPI", value: vendor.RmiVendorNpi },
      { name: "vendorName", value: vendor.RmiVendorName },
      { name: "vendorAddress", value: vendor.RmiStreet },
      { name: "vendorCity", value: vendor.RmiCity },
      { name: "vendorState", value: vendor.RmiState },
      { name: "vendorZip", value: vendor.RmiZip },
      { name: "vendorPhone", value: vendor.RmiPhone },
    ]);
  };

  const handleSelectFacility = (value: string) => {
    let facility = JSON.parse(value);
    setSelectedFacility(facility);
    form.setFields([
      { name: "facilityName", value: facility.LastName },
      { name: "facilityAddress", value: facility.Street },
      { name: "facilityCity", value: facility.City },
      { name: "facilityState", value: facility.State },
      { name: "facilityZip", value: facility.Zip },
    ]);
    form.validateFields([
      "facility",
      "facilityName",
      "facilityAddress",
      "facilityCity",
      "facilityState",
      "facilityZip",
    ]);
  };

  const checkMultipleEMCodes = async () => {
    //check if ambulatory codes set boolean to true
    let [
      hasAmbulatory,
      hasGCodes,
      hasQualityMeasureCode,
      hasEMCode,
      hasModifier25,
    ] = Array(5).fill(false);
    let emCount = 0;

    procDataSource.map((val) => {
      if (!hasAmbulatory && AMBULATORY_CODES.includes(val.CPT))
        hasAmbulatory = true;
      if (!hasGCodes && G_CODES.includes(val.CPT)) hasGCodes = true;
      if (
        !hasQualityMeasureCode &&
        measureCodes.find((x) => x.Code === val.CPT)
      )
        hasQualityMeasureCode = true;
    });
    //check if ambulatory is false and emcodes is not empty. if not, loop through portalClaimDetails.
    if (!hasAmbulatory && EMCodes.length > 0) {
      procDataSource.map((val) => {
        // add days to emCount if emCode is found
        if (EMCodes.find((x) => x.Code === val.CPT)) {
          hasEMCode = true;
          emCount++;
        }
        // if part of exclusion codes, and has modifier 25, allow for as many em codes as needed.
        if (
          EM_EXCLUSION_CODES.includes(val.CPT) &&
          (val.modifiers
            ? JSON.parse(val.modifiers).RmiModif === "25"
            : false) &&
          hasEMCode
        ) {
          hasModifier25 = true;
        }
      });
    }

    if (hasEMCode && emCount > 1 && !hasModifier25) {
      Modal.error({
        title: "Multiple E&M Codes.",
        content:
          "You have more than one E&M Code, For Claims, you can have only one E&M code.",
      });
      return false;
    }
    if (!hasEMCode && EMCodes.length > 0 && hasQualityMeasureCode) {
      // open EM Code modal
      setEMCodeSelectionModalVisible(true);
      return false;
    } else if (
      hasGCodes &&
      portalClaimMaster.RmiClaimSource === "E" &&
      props.provider.RmiClass === "P"
    ) {
      confirm({
        title: "ATTENTION",
        content:
          "PLEASE MAKE SURE YOU SUBMIT ANY HCC DX CODES FOR THIS DATE OF SERVICE",
        type: "warning",
        maskClosable: false,
        okText: "Proceed With Claim",
        cancelText: "Add DX Codes",
        onOk() {
          form.validateFields().then((values) => onSubmit(values));
        },
        onCancel() {
          return Promise.resolve(false);
        },
      });
      return false;
    } else {
      return true;
    }
  };

  // Upload Files
  const handleUpload = (claimRefNo: string) => {
    const fileData = new FormData();
    attachmentList.forEach((file: any) => {
      fileData.append("file", file, file.name);
    });

    fileData.append("rmiCompanyId", props.claim.RmiCompanyId);
    fileData.append("rmiClaimReferenceNo", claimRefNo);
    fileData.append("rmiUserId", sessionStorage.getItem("user_id")!);
    fileData.append("date", moment().toString());
    fileData.append("updateAttachment", "0");

    return props
      .uploadAttachment(fileData)
      .then(() => {
        notifier.success("Document successfully uploaded.");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const onSubmitAlert = () => {
    setIsSubmitting(true);
    setSubmitFlag(true);
    form
      .validateFields()
      .then(async (values) => {
        // EM Code check
        let emCodeCheck = await checkMultipleEMCodes();
        if (emCodeCheck) {
          confirm({
            title: "Are you sure you are done?",
            icon: <ExclamationCircleOutlined />,
            content:
              "The claim will be submitted after you select OK and no further changes can be made.",
            onOk: () => onSubmit(values),
            onCancel() {},
          });
        }
      })
      .catch((err) => {
        notifier.error(
          "Please resolve all field errors before submission, thank you."
        );
      });
  };

  const onSubmit = (formValues: any) => {
    // prepare diagnoses array
    let diagInfo: DiagInfo[] = [];

    diagDataSource.map((value: any) => {
      diagInfo.push({
        RmiUid: "",
        RmiClaimMasterId: portalClaimMaster.RmiUid,
        RmiIdx: value.index,
        RmiDiagRefLetter: value.letterIndex,
        RmiDiagCode: value.RmiDiagCode,
        RmiDiagDesc: value.RmiDiagDesc,
        RmiCreatedBy: "888",
        RmiModifiedBy: "888",
      });
    });

    // prepare procedure array
    let procInfo: ProcInfo[] = [];

    procDataSource.map((value: any, index: number) => {
      let diag2, diag3, diag4;
      let mod2,
        mod3,
        mod4 = "";
      if (value?.additionalDiags && value.additionalDiags.length > 0) {
        try {
          diag2 = JSON.parse(value.additionalDiags[0].diag);
        } catch {}
        try {
          value.additionalDiags[1] &&
            (diag3 = JSON.parse(value.additionalDiags[1].diag));
        } catch {}
        try {
          value.additionalDiags[2] &&
            (diag4 = JSON.parse(value.additionalDiags[2].diag));
        } catch {}
      }

      if (value?.additionalModifiers && value.additionalModifiers.length > 0) {
        try {
          mod2 = JSON.parse(value.additionalModifiers[0].modifier).RmiModif;
        } catch {}
        try {
          value.additionalModifiers[1] &&
            (mod3 = JSON.parse(value.additionalModifiers[1].modifier).RmiModif);
        } catch {}
        try {
          value.additionalModifiers[2] &&
            (mod4 = JSON.parse(value.additionalModifiers[2].modifier).RmiModif);
        } catch {}
      }

      let detailNote = "";
      if (value.procedure === "NDC")
        detailNote = `${value.procedure}${value.ndcCode ? value.ndcCode : ""} ${
          value.ndcUnit ? value.ndcUnit : ""
        }${value.ndcQty ? value.ndcQty : ""}`;
      else
        detailNote = `${value.procedure} ${
          value.additionalServiceInfo ? value.additionalServiceInfo : ""
        }`;

      procInfo.push({
        RmiUid: "",
        RmiClaimMasterId: portalClaimMaster.RmiUid,
        RmiIdx: index + 1,
        RmiDosFrom: moment(value.procedureFrom).format("MM/DD/YYYY"),
        RmiDosFromString: value.ndcFrom
          ? `${moment(value.procedureFrom).format("MMMDD,YYYY")} ${moment(
              value.ndcFrom
            ).format("HH:mm:ss")}`
          : undefined,
        RmiDosTo: moment(value.procedureTo).format("MM/DD/YYYY"),
        RmiDosToString: value.ndcTo
          ? `${moment(value.procedureTo).format("MMMDD,YYYY")} ${moment(
              value.ndcTo
            ).format("HH:mm:ss")}`
          : undefined,
        RmiTotalTime: value.ndcTimeInMinutes,
        RmiPosCode: JSON.parse(value.POS).RmiCode,
        RmiEmg: value.EMG,
        RmiCptCode: value.CPT,
        RmiCptModifier1: value.modifiers
          ? JSON.parse(value.modifiers).RmiModif
          : "",
        RmiCptModifier2: mod2,
        RmiCptModifier3: mod3,
        RmiCptModifier4: mod4,
        RmiDiagPtr: value.diagIndex,
        RmiDiagPtrLtr: value.diagRef,
        RmiDiagCode: value.diagCode,
        RmiDiagPtr2: diag2 ? diag2.index : "",
        RmiDiagPtrLtr2: diag2 ? diag2.letterIndex : "",
        RmiDiagCode2: diag2 ? diag2.RmiDiagCode : "",
        RmiDiagPtr3: diag3 ? diag3.index : "",
        RmiDiagPtrLtr3: diag3 ? diag3.letterIndex : "",
        RmiDiagCode3: diag3 ? diag3.RmiDiagCode : "",
        RmiDiagPtr4: diag4 ? diag4.index : "",
        RmiDiagPtrLtr4: diag4 ? diag4.letterIndex : "",
        RmiDiagCode4: diag4 ? diag4.RmiDiagCode : "",
        RmiCharges: value.charges,
        RmiDays: value.daysOrUnits,
        RmiEpsDt: "",
        RmiRendProviderId: value.RmiProvId,
        RmiRendProviderNpi: value.providerNPI,
        RmiRendProviderFirstName: value.RmiFirstName,
        RmiRendProviderLastName: value.RmiLastName,
        RmiCreatedBy: "888",
        RmiModifiedBy: "888",
        RmiDetailNote: detailNote,
        RmiNdcCode: value.ndcCode,
      });
    });

    let formData = {
      portalClaimMaster: {
        ...portalClaimMaster,
        RmiOtherInsuredName: formValues.insuredName
          ? formValues.insuredName
          : null,
        RmiOtherInsuredPolicy: formValues.insuredPolicyGroupNo
          ? formValues.insuredPolicyGroupNo
          : null,
        RmiOtherInsuredPlan: formValues.insurancePlan
          ? formValues.insurancePlan
          : null,
        RmiEmploymentRelated: patientInfo.employmentAccident
          ? patientInfo.employmentAccident
          : null,
        RmiAutoRelated: patientInfo.autoAccident
          ? patientInfo.autoAccident
          : null,
        RmiAutoAccidentState: patientInfo.autoAccidentState
          ? patientInfo.autoAccidentState
          : null,
        RmiOtherRelated: patientInfo.otherAccident
          ? patientInfo.otherAccident
          : null,
        RmiInsuredOtherPlan: patientInfo.otherPlan
          ? patientInfo.otherPlan
          : null,
        RmiDateOfCurrent: currentDate !== "" ? currentDate : null,
        RmiDateOfSimilar: otherDate !== "" ? otherDate : null,
        RmiDateNoWorkFrom: formValues.unavailableFrom
          ? formValues.unavailableFrom
          : null,
        RmiDateNoWorkTo: formValues.unavailableTo
          ? formValues.unavailableTo
          : null,
        RmiReferringProviderId: null,
        RmiReferringProvider: formValues.provider ? formValues.provider : null,
        RmiReferringProviderNpi: formValues.npi ? formValues.npi : null,
        RmiHospitalizedFrom: formValues.hospitalFrom
          ? formValues.hospitalFrom
          : null,
        RmiHospitalizedTo: formValues.hospitalTo ? formValues.hospitalTo : null,
        RmiOutsideLab: formValues.outsideLab ? formValues.outsideLab : null,
        RmiOutsideLabCharge: formValues.charges ? formValues.charges : null,
        RmiPatientAcctNo: patientAccount,
        RmiMedicaidResubCode: formValues.resubCode
          ? formValues.resubCode
          : null,
        RmiMedicaidOrigRefNo: formValues.originalRefNo
          ? formValues.originalRefNo
          : null,
        RmiPriorAuthNo: formValues.priorAuthNo ? formValues.priorAuthNo : null,
        RmiTotalCharge: totalCharges,
        RmiAmountPaid: amountPaid,
        RmiBalanceDue: balance,
        RmiFacilityName: formValues.facilityName
          ? formValues.facilityName
          : null,
        RmiFacilityAddrId: selectedFacility.AddressId,
        RmiFacilityAddress: formValues.facilityAddress
          ? formValues.facilityAddress
          : null,
        RmiFacilityCity: formValues.facilityCity
          ? formValues.facilityCity
          : null,
        RmiFacilityState: formValues.facilityState
          ? formValues.facilityState
          : null,
        RmiFacilityZip: formValues.facilityZip ? formValues.facilityZip : null,
        RmiFacilityNpi: formValues.facilityNPI ? formValues.facilityNPI : null,
        RmiFacilityId: null,
        RmiFedTaxId: formValues.vendorTaxId
          ? formValues.vendorTaxId
          : portalClaimMaster.RmiFedTaxId, // Add taxId to the create claim payload
        RmiBillingProviderId: formValues.vendor
          ? JSON.parse(formValues.vendor).RmiVendorId
          : null,
        RmiBillingProviderName: formValues.vendorName
          ? formValues.vendorName
          : null,
        RmiBillingProviderAddrId: null,
        RmiBillingProviderAddress: formValues.vendorAddress
          ? formValues.vendorAddress
          : null,
        RmiBillingProviderCity: formValues.vendorCity
          ? formValues.vendorCity
          : null,
        RmiBillingProviderState: formValues.vendorState
          ? formValues.vendorState
          : null,
        RmiBillingProviderZip: formValues.vendorZip
          ? formValues.vendorZip
          : null,
        RmiBillingProviderPhone: formValues.vendorPhone
          ? formValues.vendorPhone
          : null,
        RmiBillingProviderNpi: formValues.vendorNPI
          ? formValues.vendorNPI
          : null,
        RmiPosCode: pos ? pos.replace(/[^0-9]/g, "") : null,
        RmiProvId: props.provider.RmiProvId ? props.provider.RmiProvId : null,
        RmiProvKeyId: props.claim.RmiProviderKeyId
          ? props.claim.RmiProviderKeyId
          : null,
        RmiClaimNote: formValues.additionalClaimInfo
          ? formValues.additionalClaimInfo
          : null,
        RmiClaimSource: "I", // TODO:
      },
      portalClaimDetails: procInfo,
      portalClaimDiags: diagInfo,
      qualifier: formValues.procedure,
      unit: formValues.ndcUnit,
    };

    if (procInfo.length === 0) {
      notifier.error("Please add one or more details.");
      return;
    }

    return props
      .save(formData)
      .then((response: any) => {
        props.setClaimConfirmInfo(response);
        handleUpload(response.ClaimReferenceNo);
        props.setPage("claim-confirm");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  return (
    <Form
      form={form}
      name="claimForm"
      onFinish={onSubmit}
      initialValues={{
        procedure: "NDC",
        ndcUnit: "ML",
        ndcQty: "1",
        ndcFrom: moment(),
        ndcTo: moment(),
        procedureFrom: moment(props.dos),
        procedureTo: moment(props.dos),
        emg: "N",
        units: "1",
      }}
    >
      <LoadingIndicator
        isLoading={
          props.isCreating ||
          props.isFetchingVendors ||
          props.isFetchingPOS ||
          props.isFetchingNPI ||
          props.isFetchingModifierCodes
        }
        fullScreen
      />
      <OtherProviderModal
        otherProviders={otherProviders}
        isFetching={props.isFetchingOther}
        visible={otherProviderModalVisible}
        onCancel={() => setOtherProviderModalVisible(false)}
        clickOtherProvider={clickOtherProvider}
      />
      <EMCodeSelectionModal
        EMCodeList={EMCodes}
        selectedEMCode={selectedEMCode}
        setSelectedEMCode={setSelectedEMCode}
        visible={EMCodeSelectionModalVisible}
        onCancel={() => {
          Modal.error({
            title:
              "E&M code is required for claims with Quality Performance codes.",
          });
        }}
        onOk={() => addEMCodetoProcTable()}
      />
      <PatientInfo
        portalClaimMaster={portalClaimMaster}
        patientInfo={patientInfo}
        setPatientInfo={setPatientInfo}
        form={form}
      />
      <div className="row flex-lg-wrap justify-content-start ml-0 mt-3">
        <Title level={4}>Physician or Supplier Information</Title>
        <div className="member-search row flex-lg-wrap justify-content-start ml-0">
          <div className="col-lg-8 col-md-8">
            <FloatLabel
              label="Current Illness, Injury, or Pregnancy (LMP) Date"
              name="currentDate"
              form={form}
              small="(box 14)"
              value={currentDate}
            >
              <DatePickerLocalised
                date={currentDate}
                setDate={setCurrentDate}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="Other Date"
              name="otherDate"
              form={form}
              small="(box 15)"
              value={otherDate}
            >
              <DatePickerLocalised
                date={otherDate}
                setDate={setOtherDate}
                allowClear
              />
            </FloatLabel>

            {patientInfo.employmentAccident === "Y" && (
              <>
                <Divider />
                <FloatLabel
                  label="Unavailable to Work From"
                  name="unavailableFrom"
                  form={form}
                  small="(box 16)"
                  required
                  dependencies={["unavailableTo"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value &&
                          getFieldValue("unavailableTo") &&
                          !moment(getFieldValue("unavailableTo")).isSameOrAfter(
                            moment(value)
                          )
                        ) {
                          return Promise.reject(
                            new Error(
                              "Please enter a date that is on or before the To Date."
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <DatePickerLocalised
                    date={unavailableFrom}
                    setDate={setUnavailableFrom}
                    formInstance={form}
                    formItemName={"unavailableFrom"}
                  />
                </FloatLabel>

                <FloatLabel
                  label="Unavailable to Work To"
                  name="unavailableTo"
                  form={form}
                  small="(box 16b)"
                  required
                >
                  <DatePickerLocalised
                    date={unavailableTo}
                    setDate={setUnavailableTo}
                    formInstance={form}
                    formItemName={"unavailableTo"}
                  />
                </FloatLabel>

                <br />
              </>
            )}
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Referring Provider"
              name="provider"
              form={form}
              small="(box 17)"
              required={props.provider.RmiClass === "S"}
              dependencies={["npi"]}
              validateTrigger={["onBlur", "onChange"]}
              rules={[
                ({ getFieldValue }) => ({
                  async validator(_: any, value: any) {
                    if ((!value && !getFieldValue("npi")) || value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Must enter Referring Provider along with NPI.")
                    );
                  },
                }),
              ]}
            >
              <Input
                onChange={(e) => {
                  setReferringProvider(e.target.value);
                }}
              />
            </FloatLabel>

            <FloatLabel
              label="NPI"
              name="npi"
              form={form}
              small="(box 17b)"
              validateTrigger={["onBlur"]}
              dependencies={["provider"]}
              hasFeedback
              rules={[
                ({ getFieldValue }) => ({
                  async validator(_: any, value: any) {
                    if (
                      (!value && !getFieldValue("provider")) ||
                      (value && (await verifyNPI(value)))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This NPI does not exist on our system or is blank. Please revise your entry."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
                onChange={(e) => {
                  setNpi(e.target.value);
                }}
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Hospitalization From"
              name="hospitalFrom"
              form={form}
              small="(box 18)"
              dependencies={["hospitalTo"]}
              required={procDataSource.some((val) =>
                HOSPITALIZATION_REQUIRED_POS_CODE.includes(
                  JSON.parse(val.POS).RmiCode
                )
              )}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(__: any, value: any) {
                    if (
                      value &&
                      getFieldValue("hospitalTo") &&
                      !moment(getFieldValue("hospitalTo")).isSameOrAfter(
                        moment(value)
                      )
                    ) {
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or before the To Date."
                        )
                      );
                    } else {
                      // Check if Hospitalization From is before dosFrom and dosTo in the cpt code list, need for loop to resolve Promise.
                      // value input is just "date" while RmiDosFrom and RmiDosTo both have the database time in there...
                      const minDate = _.min(
                        procDataSource.map(
                          (value) => new Date(value.procedureFrom)
                        )
                      );
                      const maxDate = _.max(
                        procDataSource.map(
                          (value) => new Date(value.procedureTo)
                        )
                      );
                      const hospitalFromDate =
                        moment(value).format("MM/DD/YYYY");

                      if (
                        procDataSource.length !== 0 &&
                        (moment(hospitalFromDate).isAfter(
                          moment(moment(maxDate).format("MM/DD/YYYY"))
                        ) ||
                          moment(hospitalFromDate).isAfter(
                            moment(moment(minDate).format("MM/DD/YYYY"))
                          ) ||
                          (hospitalTo !== null &&
                            moment(hospitalTo).isBefore(
                              moment(moment(minDate).format("MM/DD/YYYY"))
                            )))
                      ) {
                        return Promise.reject(
                          "Hospital From Date is not in the procedure date range."
                        );
                      }
                      if (
                        procDataSource.length === 0 &&
                        (moment(hospitalFromDate).isAfter(
                          moment(moment(dosTo).format("MM/DD/YYYY"))
                        ) ||
                          moment(hospitalFromDate).isAfter(
                            moment(moment(dosFrom).format("MM/DD/YYYY"))
                          ) ||
                          (value !== null &&
                            value !== "" &&
                            hospitalTo !== null &&
                            hospitalTo !== "" &&
                            moment(hospitalTo).isBefore(
                              moment(moment(dosFrom).format("MM/DD/YYYY"))
                            )))
                      ) {
                        return Promise.reject(
                          "Hospital From Date is not in the procedure date range."
                        );
                      }
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={hospitalFrom}
                setDate={setHospitalFrom}
                formInstance={form}
                formItemName={"hospitalFrom"}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="Hospitalization To"
              name="hospitalTo"
              form={form}
              small="(box 18b)"
              rules={[
                () => ({
                  async validator(__: any, value: any) {
                    // Check if Hospitalization To is before dosFrom and dosTo in the cpt code list, need for loop to resolve Promise.
                    // value input is just "date" while RmiDosFrom and RmiDosTo both have the database time in there...
                    const minDate = _.min(
                      procDataSource.map(
                        (value) => new Date(value.procedureFrom)
                      )
                    );
                    const maxDate = _.max(
                      procDataSource.map((value) => new Date(value.procedureTo))
                    );
                    const hospitalToDate = moment(value).format("MM/DD/YYYY");

                    if (
                      procDataSource.length !== 0 &&
                      (moment(hospitalToDate).isBefore(
                        moment(moment(minDate).format("MM/DD/YYYY"))
                      ) ||
                        moment(hospitalToDate).isBefore(
                          moment(moment(maxDate).format("MM/DD/YYYY"))
                        ) ||
                        (hospitalFrom !== null &&
                          hospitalFrom !== "" &&
                          value !== null &&
                          value !== "" &&
                          moment(hospitalFrom).isAfter(
                            moment(moment(maxDate).format("MM/DD/YYYY"))
                          )))
                    ) {
                      return Promise.reject(
                        "Hospital To Date is not in the procedure date range."
                      );
                    }

                    if (
                      procDataSource.length === 0 &&
                      (moment(hospitalToDate).isBefore(
                        moment(moment(dosFrom).format("MM/DD/YYYY"))
                      ) ||
                        moment(hospitalToDate).isBefore(
                          moment(moment(dosTo).format("MM/DD/YYYY"))
                        ) ||
                        (hospitalFrom !== null &&
                          hospitalFrom !== "" &&
                          value !== null &&
                          value !== "" &&
                          moment(hospitalFrom).isAfter(
                            moment(moment(dosTo).format("MM/DD/YYYY"))
                          )))
                    ) {
                      return Promise.reject(
                        "Hospital To Date is not in the procedure date range."
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={hospitalTo}
                setDate={setHospitalTo}
                formInstance={form}
                formItemName={"hospitalTo"}
                allowClear
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Resubmission Code"
              name="resubCode"
              form={form}
              small="(box 22)"
            >
              <Select onChange={(e) => setResubCode(e!.toString())}>
                <Option value="1">1 - Original Claim</Option>
                <Option value="7">7 - Replacement of Prior Claim</Option>
                <Option value="8">8 - Void/Cancel Prior Claim</Option>
              </Select>
            </FloatLabel>

            <FloatLabel
              label="Original Ref No"
              name="originalRefNo"
              form={form}
              dependencies={["resubCode"]}
              validateTrigger={["onBlur", "onChange"]}
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    if (
                      ((resubCode === ResubCodes.REPLACEMENT ||
                        resubCode === ResubCodes.VOID) &&
                        value) ||
                      (resubCode !== ResubCodes.REPLACEMENT &&
                        resubCode !== ResubCodes.VOID)
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please enter original reference number.")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Outside Lab?"
              name="outsideLab"
              small="(box 20)"
              form={form}
              value={"Yes"}
            >
              <Radio.Group className="radio">
                <Radio.Button value="Y">Yes</Radio.Button>
                <Radio.Button value="N">No</Radio.Button>
              </Radio.Group>
            </FloatLabel>

            <FloatLabel label="Charges" name="charges" form={form} hasIcon>
              <Input
                type="number"
                prefix="$"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <FloatLabel
              label="Prior Auth No"
              name="priorAuthNo"
              small="(box 23)"
              form={form}
              validateTrigger={["onBlur"]}
              hasFeedback
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    let authDetail = await getAuthDetail(value);
                    if (!value || authDetail.length !== 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This Auth does not exist in our system or this member does not possess this Auth Number. Please revise your entry."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>
          </div>

          <div className="col-lg-24 col-md-4 mb-1">
            <Title level={5}>
              Additional Claim Information{" "}
              <span style={{ fontSize: "11px" }}>(box 19)</span>
            </Title>
            <Form.Item name="additionalClaimInfo">
              <Input />
            </Form.Item>
          </div>

          <div className="col-lg-24 col-md-24 mb-3">
            <Title level={5}>
              Diagnosis Information (ICD 10){" "}
              <span style={{ color: "red" }}>*</span>{" "}
              <span style={{ fontSize: "11px" }}>
                (Min 1, Max 12 boxes 21A-L)
              </span>
            </Title>
            <div style={{ color: "red" }}>{diagErrorMsg}</div>
            {diagDataSource.length !== 0 && (
              <Table
                columns={diagColumns}
                dataSource={diagDataSource}
                pagination={false}
                rowKey={"RmiDiagCode"}
              />
            )}
            <Form.Item
              name="diagnosis"
              validateTrigger={["onBlur"]}
              rules={[
                {
                  required: diagDataSource.length === 0,
                  message: "Please add at least 1 Diagnosis.",
                },
              ]}
            >
              <AutoComplete
                id="diagnosis"
                style={{ width: "100%" }}
                ref={scrollToRef}
                onSearch={debounce(handleDiagCodeSearch, 500)}
                onSelect={handleSelectDiagCode}
                placeholder="Search for Diagnosis Codes..."
                notFoundContent={
                  "Not found. Please type more than 3 characters or try your search again."
                }
                defaultActiveFirstOption={true}
                onKeyDown={(e) =>
                  tabSelectEvent(e, diagCodeResult, "diagnosis")
                }
              >
                {props.isFetchingDiagCodes ? (
                  <Option value="">
                    <Spin />
                  </Option>
                ) : (
                  diagCodeResult.map((value: any) => (
                    <Option key={value.diagcode} value={JSON.stringify(value)}>
                      {value.diagcode}
                    </Option>
                  ))
                )}
              </AutoComplete>
            </Form.Item>
          </div>

          <div className="col-lg-24 col-md-24 mb-3">
            <Title level={5}>
              Procedure Information{" "}
              <span style={{ fontSize: "11px" }}>(boxes 24A-J)</span>
            </Title>
            <Form.Item
              name="procTable"
              validateStatus={procDataSource.length === 0 ? "error" : "success"}
              help={
                procDataSource.length === 0 &&
                submitFlag &&
                "Please add at least 1 Service Line."
              }
              style={{ marginTop: "-40px" }}
            />
          </div>

          {procDataSource.length !== 0 && (
            <ProcedureTable
              procDataSource={procDataSource}
              setProcDataSource={setProcDataSource}
              form={form}
              modifierCodes={modifierCodes}
              isFetchingModifierCodes={props.isFetchingModifierCodes}
              diagDataSource={diagDataSource}
              setPosOffice={setPosOffice}
              setPatientAccount={setPatientAccount}
              setAmountPaid={setAmountPaid}
              amountPaid={amountPaid}
              setTotalCharges={setTotalCharges}
              setBalance={setBalance}
              checkCPTCompatibility={checkCPTCompatibility}
              companyId={props.claim.RmiCompanyId}
              getRmiProvKeyId={props.getRmiProvKeyId}
              getNameAndIdFromRmiProvKeyId={props.getNameAndIdFromRmiProvKeyId}
              verifyRenderingNpi={verifyRenderingNpi}
              getNdcCodes={props.getNdcCodes}
              checkIfNdcIsRequired={props.checkIfNdcIsRequired}
              isFetchingNdcCodes={props.isFetchingNdcCodes}
            />
          )}
          <div className="procedure-info row flex-lg-wrap justify-content-start mb-3 ml-0">
            <div className="col-xs-4 col-md-4 mb-3">
              <FloatLabel label="Select:" name="procedure" form={form}>
                <Select value={procedure} onSelect={(e) => setProcedure(e)}>
                  <Option value="NDC">NDC</Option>
                  <Option value="ZZ">ZZ</Option>
                </Select>
              </FloatLabel>
            </div>
            {procedure !== "ZZ" ? (
              <>
                <div className="col-xs-6 col-md-6 mb-3">
                  <FloatLabel
                    label="NDC Code:"
                    name="ndcCode"
                    form={form}
                    validateTrigger={["onBlur"]}
                    dependencies={["ndcQty"]}
                    hasFeedback
                    required={
                      !isSubmitting &&
                      datesVisible &&
                      parseInt(form.getFieldValue(["ndcQty"])) > 1
                    }
                    rules={[
                      () => ({
                        validator: validateNDC,
                      }),
                      () => ({
                        async validator(_: any, value: any) {
                          if (ndcRequired && !value && !isSubmitting) {
                            //
                            return Promise.reject(
                              new Error("NDC Code is required.")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    float
                  >
                    <AutoComplete
                      id="ndc-code"
                      style={{ width: "100%" }}
                      onSearch={debounce(handleNdcCodeSearch, 500)}
                      onSelect={handleSelectNdcCode}
                      notFoundContent={
                        "Not found. Please type more than 3 characters or try your search again."
                      }
                      defaultActiveFirstOption={true}
                      onKeyDown={(e) =>
                        tabSelectEvent(e, ndcCodeResult, "ndc-code")
                      }
                      maxLength={11}
                      allowClear
                    >
                      {props.isFetchingNdcCodes ? (
                        <Option value="">
                          <Spin />
                        </Option>
                      ) : (
                        ndcCodeResult.map((option: any, key: number) => (
                          <Option key={key} value={JSON.stringify(option)}>
                            {option.codeName}
                          </Option>
                        ))
                      )}
                    </AutoComplete>
                  </FloatLabel>
                </div>
                <div className="col-xs-3 col-md-3 mb-3">
                  <FloatLabel label="Unit:" name="ndcUnit" form={form}>
                    <Select>
                      <Option value="ME">ME</Option>
                      <Option value="ML">ML</Option>
                      <Option value="UN">UN</Option>
                      <Option value="GR">GR</Option>
                      <Option value="F2">F2</Option>
                    </Select>
                  </FloatLabel>
                </div>
                <div className="col-xs-3 col-md-3 mb-3">
                  <FloatLabel
                    label="Qty:"
                    name="ndcQty"
                    form={form}
                    rules={[
                      { required: !isSubmitting, message: "Required" },
                      () => ({
                        async validator(_: any, value: string) {
                          if (
                            value &&
                            (isNaN(parseFloat(value)) || parseFloat(value) <= 0)
                          ) {
                            return Promise.reject(
                              new Error("Incorrect ndcQty")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    hasIcon
                    star
                  >
                    <Input
                      type="number"
                      onKeyDown={(evt) =>
                        (evt.key === "e" ||
                          evt.key === "+" ||
                          evt.key === "-") &&
                        evt.preventDefault()
                      }
                    />
                  </FloatLabel>
                </div>
                {datesVisible && (
                  <div className="row col-lg-8 col-md-4 col-xs-4">
                    <div className="col-xs-12 col-md-12">
                      <FloatLabel label="From:" name="ndcFrom" form={form}>
                        <TimePicker
                          placeholder=""
                          use12Hours
                          showNow
                          onBlur={() => calculateTotalTime()}
                          allowClear={false}
                        />
                      </FloatLabel>
                      <div className="btn-wrapper">
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            form.resetFields(["ndcFrom", "ndcTo"]);
                            calculateTotalTime();
                          }}
                          style={{ width: "100%", margin: "0 4px 0 0" }}
                        >
                          RESET
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            form.setFields([
                              { name: "ndcFrom", value: undefined },
                              { name: "ndcTo", value: undefined },
                              { name: "ndcTime", value: undefined },
                            ]);
                            setDatesVisible(false);
                          }}
                          style={{ width: "100%", margin: "0 0 0 4px" }}
                        >
                          REMOVE
                        </Button>
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-12">
                      <FloatLabel
                        label="To:"
                        name="ndcTo"
                        form={form}
                        validateStatus={"success"}
                        help={"Total time: " + totalTime}
                      >
                        <TimePicker
                          placeholder=""
                          use12Hours
                          showNow
                          onBlur={() => calculateTotalTime()}
                          allowClear={false}
                        />
                      </FloatLabel>
                    </div>
                  </div>
                )}
                {!datesVisible && (
                  <div className="col-xs-8 col-md-8 mt-1 btn-wrapper">
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={() => {
                        form.setFields([
                          { name: "ndcFrom", value: moment() },
                          { name: "ndcTo", value: moment() },
                        ]);
                        setDatesVisible(true);
                        calculateTotalTime();
                      }}
                    >
                      ADD NDC TIME
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <div className="col-xs-12 col-md-12 mb-3">
                <FloatLabel
                  label="Additional Service Information"
                  name="additionalServiceInfo"
                  form={form}
                >
                  <Input />
                </FloatLabel>
              </div>
            )}
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="From Date:"
              name="procedureFrom"
              form={form}
              dependencies={["procedureTo"]}
              required={!isSubmitting}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(_: any, value: any) {
                    if (value && moment(value).isAfter(moment().endOf("day"))) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error("Enter a date that is today or earlier")
                      );
                    }

                    if (
                      value &&
                      getFieldValue("procedureTo") &&
                      !moment(getFieldValue("procedureTo")).isSameOrAfter(
                        moment(value)
                      )
                    ) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or before the To Date."
                        )
                      );
                    }

                    setDisableCptCode(false);
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={dosFrom}
                setDate={setDosFrom}
                formInstance={form}
                formItemName={"procedureFrom"}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="To Date:"
              name="procedureTo"
              form={form}
              dependencies={["procedureFrom"]}
              required={!isSubmitting}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(_: any, value: any) {
                    if (value && moment(value).isAfter(moment().endOf("day"))) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error("Enter a date that is today or earlier")
                      );
                    }

                    if (
                      value &&
                      getFieldValue("procedureFrom") &&
                      !moment(getFieldValue("procedureFrom")).isSameOrBefore(
                        moment(value)
                      )
                    ) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or after the From Date."
                        )
                      );
                    }

                    setDisableCptCode(false);
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={dosTo}
                setDate={setDosTo}
                formInstance={form}
                formItemName={"procedureTo"}
                allowClear
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="POS"
              name="pos"
              form={form}
              rules={[{ required: !isSubmitting, message: "Required" }]}
              star
            >
              <Select
                id="pos"
                showSearch
                loading={props.isFetchingPOS}
                defaultActiveFirstOption={true}
                onKeyDown={(e) => tabSelectEvent(e, posList, "pos")}
              >
                {posList.map((option: any, key: number) => {
                  return (
                    <Option key={key} value={JSON.stringify(option)}>
                      {option.Code}
                    </Option>
                  );
                })}
              </Select>
            </FloatLabel>

            <FloatLabel
              label="EMG"
              name="emg"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      value.trim().toUpperCase() !== "N" &&
                      value.trim().toUpperCase() !== "Y"
                    ) {
                      return Promise.reject(
                        new Error("Emergency value incorrect. Must be Y or N.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <Input />
            </FloatLabel>
          </div>

          <div className="col-lg-8 col-md-4">
            <FloatLabel
              label="CPT/HCPCS"
              name="cpt"
              form={form}
              float
              rules={[
                () => ({
                  async validator(_: any) {
                    if (!cpt.RmiProcCode && !isSubmitting) {
                      return Promise.reject(
                        new Error(
                          "Please select a CPT code from the dropdown list."
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <AutoComplete
                id="cpt-code"
                style={{ width: "100%" }}
                onSearch={debounce(handleCPTCodeSearch, 500)}
                onSelect={handleCPTCodeSelect}
                placeholder="Search for CPT Codes..."
                notFoundContent={
                  "Not found. Please type more than 2 characters or try your search again."
                }
                onKeyDown={(e) => tabSelectEvent(e, CPTCodesResult, "cpt-code")}
                defaultActiveFirstOption={true}
                allowClear
                disabled={
                  disableCptCode ||
                  !form.getFieldValue("procedureFrom") ||
                  !form.getFieldValue("procedureTo")
                }
              >
                {props.isFetchingCPTCodes ? (
                  <Option value="">
                    <Spin />
                  </Option>
                ) : (
                  CPTCodesResult.map((value: any) => (
                    <Option
                      key={value.RmiProcCode}
                      value={JSON.stringify(value)}
                    >
                      {value.ServiceCode}
                    </Option>
                  ))
                )}
              </AutoComplete>
            </FloatLabel>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="Modifier 1"
                  name="modifier"
                  form={form}
                  className="mb-4"
                >
                  <Select
                    id="modifier"
                    showSearch
                    loading={props.isFetchingModifierCodes}
                    onKeyDown={(e) =>
                      tabSelectEvent(e, modifierCodes, "modifier")
                    }
                    defaultActiveFirstOption={true}
                    allowClear
                  >
                    {modifierCodes.map((value: any) => (
                      <Option
                        key={value.RmiCodeDesc}
                        value={JSON.stringify(value)}
                      >
                        {value.RmiCodeDesc}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>

                <Form.List name="additionalModifiers">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(
                        ({ key, name, fieldKey, ...restField }, index) => (
                          <Space key={key} align={"baseline"}>
                            <Form.Item
                              {...restField}
                              name={[name, "modifier"]}
                              fieldKey={[fieldKey, "modifier"]}
                            >
                              <Select
                                id={"additional-modifiers" + index}
                                showSearch
                                loading={props.isFetchingModifierCodes}
                                onKeyDown={(e) =>
                                  tabSelectEvent(
                                    e,
                                    modifierCodes,
                                    "additional-modifiers" + index
                                  )
                                }
                                defaultActiveFirstOption={true}
                                placeholder={"Modifier " + (index + 2)}
                                style={{ width: "175px" }}
                              >
                                {modifierCodes.map((value: any) => (
                                  <Option
                                    key={value.RmiCodeDesc}
                                    value={JSON.stringify(value)}
                                  >
                                    {value.RmiCodeDesc}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>

                            <CloseOutlined onClick={() => remove(name)} />
                          </Space>
                        )
                      )}

                      {fields.length < 3 && (
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Modifier
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="Diagnosis 1"
                  name="additionalDiags"
                  form={form}
                  rules={[{ required: !isSubmitting, message: "Required" }]}
                  star
                  className="mb-4"
                >
                  <Select
                    onSelect={(value: any) =>
                      setAdditionalDiags(JSON.parse(value))
                    }
                  >
                    {diagDataSource.map((value: any, index: number) => (
                      <Option
                        key={value.RmiDiagCode}
                        value={JSON.stringify({
                          ...value,
                          index: index + 1,
                          letterIndex: toLetters(index + 1),
                        })}
                      >
                        {value.RmiDiagCode}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>

                <Form.List name="additionalAddedDiags">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space key={key} align={"baseline"}>
                          <Form.Item
                            {...restField}
                            name={[name, "diag"]}
                            rules={[
                              { required: !isSubmitting, message: "Required" },
                            ]}
                          >
                            <Select
                              placeholder={<>Diagnosis {index + 2}</>}
                              style={{ width: "175px" }}
                            >
                              {diagDataSource.map(
                                (value: any, index: number) => (
                                  <Option
                                    key={value.RmiDiagCode}
                                    value={JSON.stringify({
                                      ...value,
                                      index: index + 1,
                                      letterIndex: toLetters(index + 1),
                                    })}
                                  >
                                    {value.RmiDiagCode}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>

                          <CloseOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}

                      {fields.length < 3 && (
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Diagnosis
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Charges"
              name="procedureCharges"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      (isNaN(parseInt(value)) || parseInt(value) <= 0)
                    ) {
                      return Promise.reject(new Error("Incorrect charges."));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              hasIcon
              star
            >
              <Input
                prefix="$"
                type="number"
                onKeyPress={(e: any) =>
                  !validateCharges(e) && e.preventDefault()
                }
                onKeyDown={(evt) =>
                  (evt.key === "e" || evt.key === "+" || evt.key === "-") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <FloatLabel
              label="Days/Units"
              name="units"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      (isNaN(parseInt(value)) || parseInt(value) <= 0)
                    ) {
                      return Promise.reject(
                        new Error("Value must be greater than zero.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Rendering Provider"
              name="renderingProvider"
              form={form}
              validateTrigger={["onBlur"]}
              hasFeedback
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    if (
                      (isSubmitting ||
                        !value ||
                        (await validateRenderingNpi(value))) &&
                      (await verifyRenderingNpi(value))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This NPI is not valid for rendering provider. Please enter a valid Type 1 NPI."
                      )
                    );
                  },
                }),
                { required: !isSubmitting, message: "Required" },
              ]}
              star
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <div className="btn-wrapper">
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() => validateProcedure()}
              >
                Add
              </Button>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 mt-3">
            <Title level={5}>
              Billing Provider Information{" "}
              <span style={{ fontSize: "11px" }}>(box 33)</span>
            </Title>
            <span className="date-range-alert">
              Please select a TIN that falls within the active period of the
              DOS.
            </span>
            <div className="row flex-lg-wrap justify-content-start mb-3">
              <div className="col-lg-24 col-md-24">
                <FloatLabel label="TIN" name="vendorTaxId" form={form} required>
                  <Select
                    onSelect={handleSelectVendor}
                    loading={props.isFetchingVendors}
                    defaultValue={form.getFieldValue("vendorTaxId")}
                  >
                    {vendors.map((value: any) => (
                      <Option
                        key={value.RmiVendorId}
                        value={JSON.stringify(value)}
                      >
                        {value.RmiVendorId}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="TIN Active From"
                  name="vendorFromDate"
                  form={form}
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: any) {
                        const currentFormValues = form.getFieldsValue();
                        const vendorFromDate = currentFormValues.vendorFromDate;
                        const vendorToDate = currentFormValues.vendorToDate;
                        if (
                          value &&
                          dosFrom &&
                          (moment(dosFrom).isBefore(moment(vendorFromDate)) ||
                            moment(dosFrom).isAfter(moment(vendorToDate)))
                        ) {
                          return Promise.reject(
                            new Error(
                              "The TIN active date range does not align with the dates of service. Please select a different vendor."
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    readOnly
                    style={{ backgroundColor: "#f5f5f5", color: "#333" }}
                  />
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="TIN Active To"
                  name="vendorToDate"
                  form={form}
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: any) {
                        const currentFormValues = form.getFieldsValue();
                        const vendorFromDate = currentFormValues.vendorFromDate;
                        const vendorToDate = currentFormValues.vendorToDate;
                        if (
                          value &&
                          dosTo &&
                          (moment(dosTo).isBefore(moment(vendorFromDate)) ||
                            moment(dosTo).isAfter(moment(vendorToDate)))
                        ) {
                          return Promise.reject(
                            new Error(
                              "The TIN active date range does not align with the dates of service. Please select a different vendor."
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    readOnly
                    style={{ backgroundColor: "#f5f5f5", color: "#333" }}
                  />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="NPI"
                  name="vendorNPI"
                  form={form}
                  shouldUpdate
                  validateTrigger={["onBlur"]}
                  dependencies={["facilityNPI"]}
                  hasFeedback
                  validateStatus={sameNPI ? "warning" : undefined}
                  help={
                    sameNPI
                      ? "Are you sure? Facility NPI should NOT be the same as the billing provider's NPI. Please revise your entry."
                      : undefined
                  }
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value !== "" &&
                          value === getFieldValue("facilityNPI")
                        ) {
                          setSameNPI(true);
                          return;
                        }

                        if (!value || (await verifyNPI(value))) {
                          setSameNPI(false);
                          return Promise.resolve();
                        }

                        setSameNPI(false);
                        return Promise.reject(
                          new Error(
                            "This NPI does not exist on our system. Please revise your entry."
                          )
                        );
                      },
                    }),
                  ]}
                  required
                  float
                >
                  <Input placeholder="Enter NPI..." />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Name"
                  name="vendorName"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Address"
                  name="vendorAddress"
                  form={form}
                  required
                  float
                  validateTrigger={["onBlur", "onChange"]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="City"
                  name="vendorCity"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="State"
                  name="vendorState"
                  form={form}
                  required
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || states.includes(value.toUpperCase())) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid State"));
                      },
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-8 col-md-8">
                <FloatLabel
                  label="Zip"
                  name="vendorZip"
                  form={form}
                  required
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || value.match(/^\d{5}(-?\d{4})?(?!-)$/)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid Zip Code"));
                      },
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel label="Phone" name="vendorPhone" form={form} float>
                  <Input type="tel" />
                </FloatLabel>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 mt-3">
            <Title level={5}>
              Facility Information{" "}
              <span style={{ fontSize: "11px" }}>(box 32)</span>
            </Title>
            <div className="row flex-lg-wrap justify-content-start mb-3">
              <div className="col-lg-24 col-md-24">
                {!posOffice && (
                  <Alert
                    message="Facility information is required when place of service (POS) is not an office (11), telehealth (02) or telehealth (10)."
                    type="error"
                  />
                )}

                <FloatLabel
                  label="NPI Type 2"
                  name="facilityNPI"
                  form={form}
                  required
                  dependencies={["vendorNPI"]}
                  validateTrigger={["onBlur", "onChange"]}
                  hasFeedback
                  validateStatus={sameNPI ? "warning" : undefined}
                  help={
                    sameNPI
                      ? "If services were performed at your normal office location, please leave blank. If performed outside your normal office location, please include the facility NPI (NPI Type 2)."
                      : undefined
                  }
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value !== "" &&
                          value === getFieldValue("vendorNPI")
                        ) {
                          setSameNPI(true);
                          return;
                        }

                        if (!value || (await verifyNPI(value))) {
                          setSameNPI(false);
                          return Promise.resolve();
                        }
                        setSameNPI(false);
                        return Promise.reject(
                          new Error(
                            "This NPI does not exist on our system. Please revise your entry."
                          )
                        );
                      },
                      validateTrigger: "onBlur",
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Facility"
                  name="facility"
                  form={form}
                  value="Placeholder"
                  required
                >
                  <Select
                    placeholder="Select Facility"
                    onSelect={handleSelectFacility}
                    loading={props.isFetchingFacilities}
                    disabled={facilities.length === 0}
                  >
                    {facilities.map((facility, index) => (
                      <Option key={index} value={JSON.stringify(facility)}>
                        {facility.LastName}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Enter Facility Name"
                  name="facilityName"
                  form={form}
                  required
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Address"
                  name="facilityAddress"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (
                          !value ||
                          !value.match(
                            /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|n|num|number)?\d+))|(p(ost|ostal)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(#|n|num|number)*\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(#|n|num|number)? *\d+|(#|n|num|number) *\d+)/i
                          )
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Address cannot be a PO Box.")
                        );
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="City"
                  name="facilityCity"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="State"
                  name="facilityState"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || states.includes(value.toUpperCase())) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid State"));
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-8 col-md-8">
                <FloatLabel
                  label="Zip"
                  name="facilityZip"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || value.match(/^\d{5}(-?\d{4})?(?!-)$/)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid Zip Code"));
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-3">
          Required Fields <span style={{ color: "red" }}>*</span>
        </p>
        <div className="col-lg-24 col-md-24 mt-2 mb-3">
          <DropzoneLocal
            fileList={attachmentList}
            setFileList={setAttachmentList}
          />
        </div>

        <div className="col-lg-24 col-md-24 mt-2">
          <div className="btn-wrapper">
            <Button
              type="primary"
              onClick={onSubmitAlert}
              loading={
                props.isFetchingCPTCodes ||
                props.isFetchingDiagCodes ||
                props.isFetchingModifierCodes ||
                props.isFetchingNPI ||
                props.isFetchingPOS ||
                props.isFetchingVendors ||
                props.isSavingClaim ||
                props.isFetchingNdcCodes
              }
              style={{ width: "100%" }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isCreating: store.rootReducer.claim.isCreating,
  isFetchingNPI: store.rootReducer.claimNPI.isFetching,
  isFetchingOther: store.rootReducer.claimNPI.isFetchingOther,
  isCheckingDME: store.rootReducer.claimNPI.isChecking,
  isFetchingVendors: store.rootReducer.app.isFetchingVendors,
  isFetchingModifierCodes: store.rootReducer.authModifierCode.isFetching,
  isFetchingPOS: store.rootReducer.authPOS.isFetching,
  isCheckingMediCalCode: store.rootReducer.authMediCal.isChecking,
  isSearching: store.rootReducer.claimCPTCodes.isSearching,
  isFetchingDiagCodes: store.rootReducer.authDiagCodes.isFetching,
  isFetchingCPTCodes: store.rootReducer.claimCPTCodes.isFetching,
  isValidatingRenderingNPI: store.rootReducer.claimNPI.isValidating,
  isVerifyingNPI: store.rootReducer.claimNPI.isVerifying,
  isFetchingAuthDetail: store.rootReducer.claimMember.isFetchingAuth,
  isCheckingCompatibility: store.rootReducer.claimNDC.isChecking,
  isFetchingRelatedNdc: store.rootReducer.claimNDC.isFetching,
  isFetchingName: store.rootReducer.claimNPI.isFetchingName,
  isFetchingFacilities: store.rootReducer.authFacilities.isFetching,
  isUploading: store.rootReducer.claim.isUploading,
  isFetchingNdcCodes: store.rootReducer.claimNDC.isFetching,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      create,
      getProviderNPI,
      getOther,
      checkIsDME,
      getVendors,
      getAuthModifierCode,
      getPos,
      checkMediCalCode,
      searchByType,
      getDiagCodes,
      getCPTCodes,
      validateRendering,
      verify,
      getAuthDetail,
      checkCPTCompatibility,
      getRelated,
      getNdcCodes,
      checkIfNdcIsRequired,
      getNameFromNpi,
      getFacilities,
      getClaimsFacilities,
      uploadAttachment,
      getRmiProvKeyId,
      getNameAndIdFromRmiProvKeyId,
      getInvalidPrimDxInitials,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClaimInfo);
